<template>
<div class="relative">
	<div class="fixed white" style="width: 100%;" id="tool-bar">
	<v-row style="width: 100%" align="center" justify="start" class="ma-0">
		<v-col cols="12" sm="6" xs="6" md="6" lg="5" class="d-flex justify-start">
			<slot name="breadcrumbs"></slot>
		</v-col>
		<v-spacer ></v-spacer>
		<v-col cols="auto">
			<!-- export -->
			<v-menu offset-y>
				<template v-slot:activator="{ on }">
					<v-btn dark color="printingColor" class="px-2" v-on="on">
						<span class="d-flex align-center">
							<v-icon color="white">mdi-export-variant</v-icon>
							<span style="font-size: 14px">
								{{$t('JournalTablePage.export')}}
							</span>
						</span>
					</v-btn>
				</template>

				<bee-list>
					<!-- excel -->
					<bee-list-item
						context="daily_table"
						:item="exportItems[0]"
						dense
						@click="exportAs('excel')"
					></bee-list-item>

					<!-- pdf -->
					<bee-list-item
						context="daily_table"
						:item="exportItems[1]"
						dense
						@click="exportAs('pdf')"
					></bee-list-item>
				</bee-list>
			</v-menu>
		</v-col>
	</v-row>
	<v-layout wrap class="d-flex flex-row my-border rounded-lg mx-3 mb-3">
		<v-col lg="2" cols="12" class="d-flex justify-start pe-lg-0" md="3" sm="6">
			<bee-text-field :action-name="actions.GET" context="daily_table" :autofocus="true" :hide-details="true" :label="$t('JournalTablePage.search-within-caption')" v-model="keywords" @keydown-enter-prevent="search()"></bee-text-field>
		</v-col>
		<v-col md="auto" sm="6" cols="12" class="d-flex justify-start flex-column pe-lg-0">
			<bee-date-picker
				:label="$t('JournalTablePage.from-date')"
				v-model="start_date"
				class="ma-0 pa-0"
				@keydown-enter-prevent="search()"
				:hide-details="true"
				:action-name="actions.GET" context="daily_table"
			></bee-date-picker>
		</v-col>
		<v-col md="auto" sm="6" cols="12" class="d-flex justify-start flex-column pe-lg-0">
			<bee-date-picker
				class="ma-0 pa-0"
				:label="$t('JournalTablePage.to-date')"
				v-model="end_date"
				@keydown-enter-prevent="search()"
				:hide-details="true"
				:action-name="actions.GET" context="daily_table"
			></bee-date-picker>
		</v-col>
		<v-col
			cols="auto"
			md="3"
			sm="6"
			class="d-flex justify-center flex-column pt-0"
			:class="$emerald.ifLang('es', null, 'pe-lg-0')"
		>
			<bee-checkbox
				v-model="only_debit_entries"
				:label="$t('JournalTablePage.only-debit-entries')"
				outer-class="small-font-size"
				:class="$emerald.ifLang('es', 'mt-lg-2', null)"
			></bee-checkbox>
		</v-col>
		<v-col lg="auto" md="3" cols="12" class="d-flex flex-grow-1 justify-end align-center">
			<bee-btn  
				@click="search()"
				:content="$t('JournalTablePage.search')"
				color="blueGray"
				outer-class="me-3"
				:loading="loading"
				context="daily_table"
				:action-name="actions.GET"
			></bee-btn>
			<bee-btn  @click="reSet()"
				:content="$t('JournalTablePage.cancel')"
				color="deletingColor"
				:loading="loading"
				context="daily_table"
				:action-name="actions.GET"
			></bee-btn>
		</v-col>
	</v-layout>
	</div>
	<div class="ma-auto absolute" id="main" style="width: 100%; height: auto">
    <v-card flat>
		<v-card-text class="py-0 px-3">
			<bee-simple-table :fixed-header="true" :with-color="false" :zebra="false" :hide-footer="true" empty-state="dashes"
				:headers="headers"
				:highlighted-expression="(item)=>{return item.debit ? 'redLighten5' : 'greenLighten5'}"
				:items="entries || []"
				:configs="configs"
			>
			</bee-simple-table>
			<bee-simple-table
				:action-name="actions.GET" context="daily_table"
				class="pt-3" :with-color="true" :zebra="false" empty-state="none" :hide-footer="true" :configs="{...configs, currencies: configs.currencies.filter(c=>c.id != configs.financial_file.default_currency_id)}"
				:headers="sum_result_headers"
				:items="sum_result"
				@equivalent-currency-id-changed="changeSumDifferenceEquivalent($event)"
			>
			</bee-simple-table>
			<bee-simple-table
				:action-name="actions.GET" context="daily_table"
				class="pt-2 mb-3" :with-color="true" :zebra="false" empty-state="none" :hide-footer="true" :configs="configs"
				:headers="sum_currencies_result_headers"
				:items="sum_currencies_result" :showOnlyNumbersPatch="true"
			>
			</bee-simple-table>
		</v-card-text>
    </v-card>
	</div>
</div>
</template>
<script>
import  store  from "../../../store/index.js";
import {  mapState } from "vuex";
import ls from "../../../settings/localStorageExtension";
import actions from "../../../permissions/actions-names.js"
export default {
props: ['id'],
data: () => ({
	actions,
	sum_difference_equivalent: { amount: null, currency_id: null, money_type: null},
	journal: null,
	loading: false,
	only_debit_entries: false,
	start_date: new Date(new Date().setMonth(new Date().getMonth() - 3)).toISOString().slice(0, 10),
	end_date: new Date().toISOString().slice(0, 10),
	keywords: null,
}),
methods: {
	async search(){
			this.loading = true
			await store.dispatch("statements/fetchJournalTable", { 
				start_date: this.start_date, 
				end_date: this.end_date, 
				keywords: this.keywords, 
				only_debit_entries: this.only_debit_entries })
			.finally(() =>{
				this.journal = this.journalApi
				this.loading = false 
				this.sum_difference_equivalent = { amount: null, currency_id: null, money_type: null}
			})
	},
	reSet(){
		this.start_date = new Date(new Date().setMonth(new Date().getMonth() - 3)).toISOString().slice(0, 10);
		this.end_date = new Date().toISOString().slice(0, 10);
		this.only_debit_entries = false
		this.keywords = null
		this.account_id = null
		this.search()
	},
	changeSumDifferenceEquivalent(toCurrencyId) {
		if(toCurrencyId)
		{
			let sum_difference= this.journal?.summary?.sum_result?.sum_difference
			if(sum_difference?.amount)
			{
				let amount = sum_difference.amount
				let fromCurrecyId = sum_difference.currency_id
				store.dispatch("currencies/exchangeToCurrency",{toCurrencyId, amount, fromCurrecyId})
					.then(response => {
						_.set(this.sum_difference_equivalent,"amount", response.amount)
						_.set(this.sum_difference_equivalent,"currency_id", response.currency_id)
						_.set(this.sum_difference_equivalent,"money_type", sum_difference.money_type)
					})
			}
		}
	},

	exportAs(type){
		// type value should be 'pdf' or 'excel'
		this.$store.dispatch('reports/JournalTableReport', {
			type,
			financialFileId: this.current_financial_file.id,
			userId: ls.getLocalUser().id,
			FromDate: this.start_date,
			ToDate: this.end_date,
			keywords: this.keywords,
			onlyDebitEntries: this.only_debit_entries 
		})
	}
},
computed: {
	...mapState("configs", ["configs"]),
	...mapState({
		journalApi: state => state.statements.journal,
		current_financial_file: state => state.financialFiles.current_financial_file,
		accountingBonds: state => state.bonds.simplified_accounting_bonds,
		cashBonds: state => state.bonds.simplified_cash_bonds,
	}),

	exportItems() {
		return [
			{
				text: this.$t('JournalTablePage.export-as-excel'),
				icon: 'mdi-microsoft-excel',
				context: 'daily_table',
				action_name: actions.EXPORT_AS_PDF
			},
			{
				text: this.$t('JournalTablePage.print-journal-table'),
				icon: 'mdi-printer',
				context: 'daily_table',
				action_name: actions.EXPORT_AS_PDF
			},
		]
	},

	sum_result_headers(){ 
		return [
			{ text: '', value: '', type: '', width: '22%' },
			{
				text: this.$t('JournalTablePage.sum-result-headers.sum-debits'),
				value: 'sum_debits',
				type: 'money',
				width: '10%',
				editable: true
			},
			{
				text: this.$t('JournalTablePage.sum-result-headers.sum-credits'),
				value: 'sum_credits',
				type: 'money',
				width: '10%',
				editable: true
			},
			{
				text: this.$t('JournalTablePage.sum-result-headers.difference'),
				value: 'sum_difference',
				type: 'money',
				width: '15%',
				editable: true
			},
			{
				text: this.$t('JournalTablePage.sum-result-headers.equivalent-currency'),
				value: 'sum_difference_equivalent.currency_id',
				type: 'select',
				width: '10%'
			},
			{
				text: this.$t('JournalTablePage.sum-result-headers.currency-equivalent'),
				value: 'sum_difference_equivalent',
				type: 'money',
				width: '15%',
				editable: true
			},
			{ text: '', value: '5', type: '', width: '18%' },
		]
	},

	sum_currencies_result_headers(){ 
		return [
			{ text: '', value: 'title', type: 'string', width: '22%' },
			{
				text: this.$t('JournalTablePage.sum-currencies-result-headers.currency-debits'),
				value: 'currency_debits',
				type: 'string',
				width: '10%',
				editable: true
			},
			{
				text: this.$t('JournalTablePage.sum-currencies-result-headers.currency-credits'),
				value: 'currency_credits',
				type: 'string',
				width: '10%',
				editable: true
			},
			{ text: '', value: '', type: '', width: '58%'  },
		]
	},

	headers(){ 
		return [
			{
				text: this.$t('JournalTablePage.headers.bond-no'),
				value: 'bond_id',
				type: 'autocomplete',
				settings: {
					items: [
						...this.accountingBonds.map(c => ({ id: c.id, no: c.bond_no })),
						...this.cashBonds.map(c => ({ id: c.id, no: c.bond_no })),
					],
					itemText: 'no',
					itemValue: 'id',
				},
				width: this.$emerald.ifLang('es', '10%', '4%')
			},
			{
				text: this.$t('JournalTablePage.headers.sequence'),
				value: 'order_inside_bond',
				type: 'string',
				width: '4%'
			},
			// cannot use dublicate same value for configs  ... fast fix spacae and trim other side clean
			{
				text: this.$t('JournalTablePage.headers.account-no'),
				value: ' account_id',
				type: 'accounts-autocomplete',
				width: this.$emerald.ifLang('es', '10%', '6%'), settings: { itemText: 'accounting_no' }
			},
			{
				text: this.$t('JournalTablePage.headers.account'),
				value: 'account_id',
				type: 'accounts-autocomplete',
				width: '8%', settings: { itemText: 'name' } 
			},
			{
				text: this.$t('JournalTablePage.headers.debit'),
				value: 'debit',
				type: 'money',
				width: '10%' 
			},
			{
				text: this.$t('JournalTablePage.headers.credit'),
				value: 'credit',
				type: 'money',
				width: '10%' 
			},
			{
				text: this.$t('JournalTablePage.headers.note'),
				value: 'note',
				type: 'string',
				width: '10%'  
			},
			{
				text: this.$t('JournalTablePage.headers.currency'),
				value: 'currency_id',
				type: 'currencies-autocomplete',
				width: '5%', settings: { itemText: 'symbol' }
			},
			{
				text: this.$t('JournalTablePage.headers.currency-debit'),
				value: 'currency_debit',
				type: 'money',
				width: '10%' 
			},
			{
				text: this.$t('JournalTablePage.headers.currency-credit'),
				value: 'currency_credit',
				type: 'money',
				width: '10%' 
			},
			{
				text: this.$t('JournalTablePage.headers.price'),
				value: 'currency_price',
				type: 'numeric',
				width: '10%'
			},
			{
				text: this.$t('JournalTablePage.headers.paper-document-no'),
				value: 'paper_document_no',
				type: 'string',
				width: '3%'  
			},
			{
				text: this.$t('JournalTablePage.headers.date'),
				value: 'date',
				type: 'date',
				width: '10%' 
			},
		]
	},

	entries(){
		return this.journal?.entries ? this.journal.entries : []
	},
	sum_result(){
		return this.journal?.summary ? [].concat({...this.journal.summary?.sum_result, sum_difference_equivalent: this.sum_difference_equivalent}) : []
	},
	sum_currencies_result(){
		return this.journal?.summary ? [].concat({...this.journal.summary?.sum_currencies_result, title: this.$t('JournalTablePage.details-depending-on-currencies')}) : []
	}
},
mounted() { 
	window.observer.observe(document.querySelector("#tool-bar"))
	this.reSet()
},
async beforeRouteEnter(to, from, next) {
	let object = JSON.parse(JSON.stringify(store.state.configs.configs))
	if(Object.keys(object).length == 0)
        await store.dispatch("configs/fetchAll")
	next();
}
};
</script>
<style scoped>
.small {
	max-width: 600px;
	margin:  150px auto;
}
.small-font-size .v-label { 
	font-size: 0.8rem !important;
	padding-right: 0px !important;
}
.my-border {
	border:1px solid !important;
	border-color: #f1f1f1 !important;
}
</style>